if (!customElements.get('teema-cart-savings')) {
  customElements.define('teema-cart-savings', class extends HTMLElement {
    // Section rendering replaces the element after every cart change.
    static displayedAmounts = new Map();

    connectedCallback() {
      this.amount = Math.max(0, Number(this.dataset.amount) || 0);
      this.key = `${this.dataset.placement}:${this.dataset.currency}`;
      this.output = this.querySelector('[data-savings-amount]');
      if (!this.amount) {
        this.constructor.displayedAmounts.set(this.key, 0);
        return;
      }
      this.finalText = this.output.textContent;
      try {
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol',
        });
      } catch {
        return; // Retain Shopify's formatted amount if currency is unavailable.
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.constructor.displayedAmounts.set(this.key, this.amount);
        return;
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.animateAmount();
          }
        });
        this.observer.observe(this);
      } else {
        this.animateAmount();
      }
    }

    animateAmount() {
      const from = this.constructor.displayedAmounts.get(this.key) || 0;
      if (from === this.amount) return;
      this.classList.add('is-counting');
      let started;
      const frame = now => {
        started ??= now;
        const progress = Math.min(1, (now - started) / 700);
        const value = Math.round(from + (this.amount - from) * (1 - (1 - progress) ** 3));
        this.constructor.displayedAmounts.set(this.key, value);
        // The separate accessible label always announces only the final amount.
        this.output.textContent = progress === 1 ? this.finalText : `${this.formatter.format(value / 100)}${this.dataset.currencyCode === 'true' ? ` ${this.dataset.currency}` : ''}`;
        if (progress < 1) this.frame = requestAnimationFrame(frame);
        else this.classList.remove('is-counting');
      };
      this.frame = requestAnimationFrame(frame);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
    }
  });
}
